import { defineMessages, type IntlShape } from 'react-intl'
import { capitalise } from 'lib/string/stringUtils'

const voucherTypeMessages = defineMessages({
  printed: {
    id: 'MuLK0p6w-Os4rjQ-Nk7u',
    defaultMessage: 'Printed',
    description: 'Voucher format label for a printed experience voucher in booking and details views',
  },
  mixed: {
    id: 'TjlGNFiwE418yOMfDaBs',
    defaultMessage: 'Mixed',
    description: 'Voucher format label for a mixed experience voucher in booking and details views',
  },
  digital: {
    id: 'vSMFgtyuQvBm-zfuc4r_',
    defaultMessage: 'Digital',
    description: 'Voucher format label for a digital experience voucher in booking and details views',
  },
})

function isKnownVoucherType(voucherType: string): voucherType is keyof typeof voucherTypeMessages {
  return voucherType in voucherTypeMessages
}

export function formatExperienceVoucherTypes(
  voucherTypes: Array<string>,
  intl: IntlShape,
): string {
  return intl.formatList(
    voucherTypes.map(voucherType => (
      isKnownVoucherType(voucherType)
        ? intl.formatMessage(voucherTypeMessages[voucherType])
        : capitalise(voucherType)
    )),
  )
}
